<template>
  <div
    class="solfigr_step solfigr_step3 solfigr3 slfrssmr"
    :class="{ gw_loading: loading }"
  >
    <div class="slfrssmr_block">
      <div
        class="slfrssmr_box gw_loading_text flex-1"
        :style="items.stackpot.error ? '--clr-border:var(--clr-error)' : ''"
      >
        <div class="slfrssmr_box_title">
          {{ $t(`solfigr.titles.setup`) }}
        </div>
        <div
          class="slfrssmr_box_content f-column"
          style="gap: 0rem"
        >
          <table class="slfrssmr_box_table mr-auto">
            <tr>
              <td class="slfrssmr_box_table_td1 pr-4">
                {{ items.starting_street.title }}
              </td>
              <td class="slfrssmr_box_table_td2">
                {{ items.starting_street.value }}
              </td>
            </tr>
            <tr
              v-for="rr in items.stackpot.values"
              :key="rr.id"
            >
              <td
                class="slfrssmr_box_table_td1 pr-4"
                :class="rr.error ? 'clr-error' : ''"
              >
                {{ rr.title }}
              </td>
              <td
                class="slfrssmr_box_table_td2"
                :class="rr.error ? 'clr-error' : ''"
              >
                {{ rr.value }}
              </td>
            </tr>
          </table>
          <div
            v-if="items.stackpot.error"
            class="clr-error text-small"
          >
            {{
              $t(
                isPreflop
                  ? 'solfigr.stackpot.error_stackblinds'
                  : 'solfigr.stackpot.error_stackpot_ratio',
              )
            }}
          </div>
        </div>
      </div>

      <div
        v-for="(pp, ppIdx) in items.players.filter(i => i)"
        :key="pp.title + ppIdx"
        class="slfrssmr_box gw_loading_text flex-1"
      >
        <div class="slfrssmr_box_title d-flex">
          <div
            class="mdi mdi-account mr-1"
            :class="pp.position === 'OOP' ? 'mdi-account' : 'mdi-account-outline'"
          ></div>
          <div v-html="getPlayerHtmlPosition(pp.title)"></div>
        </div>
        <div class="slfrssmr_box_content">
          <div class="slfrssmr_ra_table">
            <div
              v-for="gg in pp.groupRange"
              :key="gg.id"
              class="slfrssmr_ra_table_rtc"
              :style="`--opacity-range: ${gg.range || 0};`"
            ></div>
          </div>
          <table class="slfrssmr_box_table ml-2">
            <tr
              v-for="rr in pp.values"
              :key="rr.id"
            >
              <td class="slfrssmr_box_table_td1">{{ rr.title }}</td>
              <td class="slfrssmr_box_table_td2">{{ rr.value }}{{ rr.unit }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div
      v-if="items.icm_tournament"
      class="slfrssmr_block d-flex flex-1"
    >
      <div class="slfrssmr_box gw_loading_text flex-1">
        <div class="slfrssmr_box_title">
          {{ $t(`solfigr.icm.tournament_structure`) }}
        </div>
        <div class="slfrssmr_box_content">
          <SolfigrIcmTournamentStructureItem
            :item="items.icm_tournament"
            class="slfrssmr_box gw_loading_text"
          />
        </div>
      </div>
    </div>

    <div
      v-if="items.icm_handDetails && items.icm_tournament"
      class="slfrssmr_block d-flex flex-1"
    >
      <div class="slfrssmr_box gw_loading_text flex-1">
        <div class="slfrssmr_box_title">
          {{ $t(`solfigr.icm.hand_details`) }}
        </div>
        <div class="slfrssmr_box_content">
          <SolfigrIcmHandDetailsItem
            :item="items.icm_handDetails"
            :players="items.players"
            :icmTournament="items.icm_tournament"
            class="slfrssmr_box gw_loading_text"
          />
        </div>
      </div>
    </div>

    <div
      v-if="items.icm_playersAndStacks"
      class="slfrssmr_block d-flex flex-1"
    >
      <div class="slfrssmr_box gw_loading_text flex-1">
        <div class="slfrssmr_box_title">
          {{ $t(`solfigr.icm.players_and_stacks`) }}
        </div>
        <div class="slfrssmr_box_content">
          <SolfigrIcmOtherStacksItem
            :item="items.icm_playersAndStacks"
            :icmTournament="items.icm_tournament"
            class="slfrssmr_box gw_loading_text"
          />
        </div>
      </div>
    </div>

    <div class="slfrssmr_block f-column flex-1">
      <div
        v-for="bbs in items.street_bet_sizes.value"
        :key="bbs.street"
        class="slfrssmr_box gw_loading_text"
      >
        <div class="slfrssmr_box_title">
          {{ $t(`common.${bbs.street.toLowerCase()}`) }}
        </div>
        <div class="slfrssmr_box_content">
          <div
            v-for="plr in bbs.position_bet_sizes"
            :key="bbs.street + plr.position"
            class="slfrssmr_sizeplayer"
          >
            <div class="slfrssmr_sizeplayer_title d-flex">
              <div
                class="mdi mr-1"
                :class="plr.position === 'OOP' ? 'mdi-account' : 'mdi-account-outline'"
              ></div>
              <div
                class="slfrssmr_sizeplayer_title_position"
                v-html="getPlayerHtmlPosition(plr.display_position)"
              ></div>
            </div>
            <div class="slfrssmr_sizeplayer_content">
              <table class="slfrssmr_box_table">
                <tr
                  v-for="(rr, rrIdx) in getPlayerItems(plr, bbs.street)"
                  :key="rr.id + rrIdx"
                >
                  <td
                    :id="rr.id"
                    class="slfrssmr_box_table_td1"
                  >
                    {{ rr.title }}
                  </td>
                  <td
                    v-if="rr.id === 'add_allin'"
                    class="slfrssmr_box_table_td2"
                  >
                    <div class="mdi mdi-check-circle clr-primary text-normal" />
                  </td>
                  <td
                    v-else-if="rr.message"
                    class="slfrssmr_box_table_td2"
                  >
                    {{ rr.message }}
                  </td>
                  <td
                    v-else
                    class="slfrssmr_box_table_td2"
                  >
                    {{ rr.value }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="slfrssmr_box gw_loading_text">
        <div class="slfrssmr_box_title">
          {{ items.advancedSizes.title }}
        </div>
        <div class="slfrssmr_box_content">
          <table class="slfrssmr_box_table">
            <tr
              v-for="rr in items.advancedSizes.values"
              :key="rr.id"
            >
              <td
                class="clr-grey"
                style="--color: var(--clr-white-0); --weight: 600"
                v-html="rr.title"
              ></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolfigrIcmTournamentStructureItem from '@/components/Dialogs/Solfigr/SolfigrIcmTournamentStructureItem'
import SolfigrIcmOtherStacksItem from '@/components/Dialogs/Solfigr/SolfigrIcmOtherStacksItem'
import SolfigrIcmHandDetailsItem from '@/components/Dialogs/Solfigr/SolfigrIcmHandDetailsItem'
import { rangesDataSkeleton } from '@/helpers/solution'
import {
  getSolfigrFields,
  getFormError,
  getSolfigrPlayer,
  getSolfigrCanRaises,
  getTournamentStructure,
  getIcmHandDetails,
  getIcmPlayersAndStacks,
} from '@/store/solfigr/solfigr_helpers'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrSummary',
  components: {
    SolfigrIcmTournamentStructureItem,
    SolfigrIcmOtherStacksItem,
    SolfigrIcmHandDetailsItem,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { String, required: true },
    loading: Boolean,
    formResult: Object,
  },
  emits: ['update:board'],
  data() {
    this.conf = getSolfigrFields()
    return {}
  },
  methods: {
    handleUpdateBoard(board) {
      this.$emit('update:board', board)
    },
    getPlayerItems(player, street) {
      let frm = this.formResult

      const isPreflop = street === 'PREFLOP'
      const betSizesKey = !isPreflop
        ? 'bet_sizes'
        : player.position !== 'IP'
          ? 'bb_preflop_bet_sizes'
          : 'sb_preflop_bet_sizes'

      const raiseSizesKey = !isPreflop ? 'raise_sizes' : 'preflop_raise_sizes'

      let allow_limp = frm.bet_sizes.street_bet_sizes[0].position_bet_sizes[0].allow_limp

      const {
        canBet, //
        canRaise,
        canSecondRaise,
        canSecondRaiseCount,
        canThirdPlusRaise,
        canDonk,
      } = getSolfigrCanRaises({
        allow_limp,
        street,
        position: `player_${player.position.toLowerCase().replace('-', '')}`,
      })

      // translate units b1 >> 1bb
      const getBB = arr =>
        arr ? arr.map(i => i && (i.includes('b') ? `${i.replace('b', '')}bb` : i)) : []

      // prettier-ignore
      let keyVals = {
        bet_type: player.type.toLowerCase(),
        ...canBet?{ bet_count: player.bet_count || 0 }:{},
        ...canRaise?{ raise_count: player.raise_count || 0 }:{},
        ...(canSecondRaiseCount ? { second_raise_count: player.second_raise_count || 0 } : {}),
        ...(canThirdPlusRaise ? { third_plus_raise_count: player.third_plus_raise_count || 0 } : {}),
        ...canDonk?{ donk_count: player.donk_count || 0}:{},

        ...canBet?{ bet_sizes: { titleKey: betSizesKey, value: getBB(player.bet_sizes) } }:{},
        ...canRaise?{ raise_sizes: { titleKey: raiseSizesKey, value: getBB(player.raise_sizes) }}:{},
        ...(canDonk ? { donk_sizes: getBB(player.donk_sizes) } : {}),

        // note - third_plus_raise_sizes are also returned for second_raise_sizes on FLOP
        // but it should not be visible in UI (BE duplicates this value there from second_raise_sizes value, and that is ok)
        ...(canSecondRaise ? { second_raise_sizes: {
                                titleKey: isPreflop ? 'second_raise_sizes' : 'second_raise_sizes_flop',
                                value: getBB(player.second_raise_sizes) } } : {}),
        ...(canThirdPlusRaise ? { third_plus_raise_sizes: getBB(player.third_plus_raise_sizes) } : {}),

        add_allin: player.add_allin || false,
      }

      let res = []

      Object.keys(keyVals).forEach((key, idx) => {
        let titleKey = keyVals[key]?.titleKey || key
        let val = keyVals[key]?.value ?? keyVals[key] ?? false

        if (!val && val !== 0) return
        if (key === 'add_allin' && !player.add_allin) return

        let conf = this.conf[key] || {}
        let messageFn = conf.message
        let message = messageFn ? messageFn(val || '') : ''
        message = message ? this.$t(`solfigr.sizes.${message}`) : ''

        res.push({
          id: key,
          conf,
          message,
          title: this.$t(`solfigr.sizes.fields.${titleKey}`),

          value: key === 'bet_type' ? this.$t(`solfigr.sizes.${val}`) : [val].flat().join(', '),
          unit: '',
        })
      })

      if (keyVals.bet_type === 'automatic') {
        res = [res[0]]
      }

      if (keyVals.bet_type === 'dynamic' && !player.use_fixed_sizes) {
        res = res.filter(i => !i.id.includes('_sizes'))
      }

      if (keyVals.bet_type === 'fixed') {
        res = res.filter(i => !i.id.includes('_count') && !i.id.includes('add_allin'))
      }

      if (isPreflop) {
        let l = res.length - 1
        res = res.map((i, idx) => {
          if (i.id.includes('_sizes') && idx === l) {
            i.title = `${i.title}+`
          }
          return i
        })
      }

      // console.log(res)
      return res
    },
  },
  computed: {
    isPreflop() {
      return this.formResult.starting_street === 'PREFLOP'
    },
    items() {
      const frm = this.formResult
      const { tableGroups } = rangesDataSkeleton()
      const solfigrPlayers = frm.players.map(p => getSolfigrPlayer({ api_player: p, tableGroups }))
      const startStreet = frm.starting_street
      const pot = this.numFixedUnit(Number(frm.pot), 'bb')
      const stack = this.numFixedUnit(Math.min(...frm.players.map(p => p.stack)), 'bb')
      const ante = this.numFixedUnit(Number(frm.ante), 'bb')
      const tournamentData = frm.tournament_data
      const icmStructure = frm.tournament_data?.tournament_structure
      const isICM = !!tournamentData

      const anteValue = `${ante} ${this.$t(
        `solfigr.ante_distribution_method.${frm.ante_distribution_method}`,
      )}`

      const blinds = frm.players.map(p => this.numFixedUnit(Number(p.blind), 'blind'))

      const allow_limp = frm.bet_sizes.street_bet_sizes[0].position_bet_sizes[0].allow_limp
        ? this.$t('solfigr.has_limps')
        : this.$t('solfigr.no_limps')

      const error = !isICM && getFormError({ formResult: frm })
      const hasRake = !!(frm.rake?.pct_of_pot || frm.rake?.cap_in_chips)

      const res = {
        starting_street: {
          title: this.$t('solfigr.streets.title'),
          value: this.$t(`solfigr.streets.${startStreet.toLowerCase()}`),
        },
        icm_tournament:
          isICM &&
          getTournamentStructure({
            type: icmStructure.type,
            payout_levels: icmStructure.payout_levels,
            bounty_instant_percentage: Number(icmStructure.bounty_instant_percentage),
          }),
        icm_playersAndStacks: isICM && getIcmPlayersAndStacks({ tournamentData }),
        icm_handDetails:
          isICM &&
          getIcmHandDetails({
            pot,
            api_oop_player: frm.players[0],
            api_ip_player: frm.players[1],
            api_oop1_player: frm.players.length > 2 ? frm.players[2] : undefined,
            type: icmStructure.type,
            bounty_instant_percentage: Number(icmStructure.bounty_instant_percentage),
          }),

        stackpot: {
          step: 'setup',
          error,
          values: [
            {
              id: 'tournamentType',
              value: this.$t(`solfigr.icm.${tournamentData ? 'icm' : 'chipev'}`),
              title: this.$t('solfigr.icm.model_type'),
            },
            !this.$store.getters.user_has_flag('SOL_3WAY') && {
              id: 'stack',
              value: stack,
              title: this.$t('solfigr.stackpot.stack'),
              error,
              hide: isICM,
            },
            {
              id: 'pot',
              value: pot,
              title: this.$t('solfigr.stackpot.pot'),
              error: error && !this.isPreflop,
              hide: this.isPreflop || isICM,
            },
            {
              id: 'ante',
              value: anteValue,
              title: this.$t('solfigr.stackpot.ante'),
              hide: !this.isPreflop,
              error: error && this.isPreflop,
            },
            {
              id: 'blind',
              value: blinds.join('/'),
              title: this.$t('solfigr.stackpot.blind'),
              hide: !this.isPreflop,
              error: error && this.isPreflop,
            },
            {
              id: 'allow_limp',
              value: allow_limp,
              title: this.$t('solfigr.stackpot.allow_limp'),
              hide: !this.isPreflop,
            },
            {
              id: 'rake_percent',
              value: this.numFixedUnit(frm.rake?.pct_of_pot, 'rake_percent'),
              title: this.$t('solfigr.stackpot.rake_percent'),
              hide: !hasRake,
            },
            {
              id: 'rake_cap',
              value: this.numFixedUnit(frm.rake?.cap_in_chips, 'rake_cap'),
              title: this.$t('solfigr.stackpot.rake_cap'),
              hide: !hasRake,
            },
            {
              id: 'preflop_rake_type',
              value: this.$t(`solfigr.rake.${frm.rake?.preflop_rake_type}`),
              title: this.$t('solfigr.preflopRakeType'),
              hide: !this.isPreflop || !hasRake,
            },
          ].filter(i => !i.hide),
        },
        advancedSizes: {
          title: this.$t('solfigr.advanced_allin_options'),
          values: [
            {
              id: 'allin_threshold',
              value: frm.bet_sizes.allin_threshold,
              title: this.$t('solfigr.sizes.advanced.allin_threshold_complete', {
                num: frm.bet_sizes.allin_threshold,
              }),
            },
            {
              id: 'allin_if_less_than',
              value: frm.bet_sizes.allin_if_less_than,
              title: this.$t('solfigr.sizes.advanced.allin_if_less_than_complete', {
                num: frm.bet_sizes.allin_if_less_than,
              }),
            },
            {
              id: 'merge_sizes_threshold',
              value: frm.bet_sizes.merge_sizes_threshold,
              title: this.$t('solfigr.sizes.advanced.merge_sizes_threshold_complete', {
                num: frm.bet_sizes.merge_sizes_threshold,
              }),
            },
            {
              id: 'max_num_raises',
              value: frm.bet_sizes.max_num_raises,
              title: this.$t('solfigr.sizes.advanced.max_num_raises_complete', {
                num: frm.bet_sizes.max_num_raises,
              }),
            },
          ],
        },
        street_bet_sizes: {
          title: this.$t('solfigr.street_bet_sizes'),
          value: frm.bet_sizes.street_bet_sizes.map(i => ({
            ...i,
            position_bet_sizes: i.position_bet_sizes.map(j => ({
              ...j,
              ...solfigrPlayers.find(p => p.position === j.position),
            })),
          })),
        },
        players: [solfigrPlayers[0], ...solfigrPlayers.slice(2), solfigrPlayers[1]] // move IP player to the end if there are more than 2 players
          .map(p =>
            this.isPreflop
              ? null
              : {
                  position: p.position,
                  title: p.display_position,
                  display_position: p.display_position,
                  groupRange: p.groupRange,
                  values: [
                    {
                      id: 'combos',
                      value: this.numFixed(p.combos),
                      title: this.$t('solfigr.ranges.combos'),
                    },
                    {
                      id: 'percentage',
                      value: this.numFixed(p.percentage * 100, 2),
                      unit: '%',
                      title: this.$t('solfigr.ranges.count'),
                    },
                    this.$store.getters.user_has_flag('SOL_3WAY') && {
                      id: 'stack',
                      value: this.numFixedUnit(
                        frm.players.find(i => i.position === p.position).stack,
                        'bb',
                      ),
                      title: this.$t('solfigr.stackpot.stack'),
                    },
                  ],
                },
          ),
      }
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
table {
  border-spacing: 0px;
  td {
    padding: 0.0625rem 0;
  }
}
.gw_loading {
  .gw_loading_text {
    border: solid 1px var(--loading_text-clr-back-1);
  }
}
.slfrssmr {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  &_block {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  &_box {
    --clr-border: var(--clr-black-3);
    background: var(--clr-black-1);
    border-radius: 4px;
    overflow: hidden;
    min-width: 14rem;
    &_content {
      font-size: 0.875rem;
      padding: 0.5rem 0.75rem;
      display: flex;
      gap: var(--solfigr-gap);
    }
    &_title {
      background: var(--clr-black-2);
      font-weight: 500;
      padding: 0.5rem 0.75rem;
    }
    &_table {
      &_td1 {
        color: var(--clr-grey-2);
        padding: 0 1rem 0 0;
      }
      &_td2 {
        font-weight: 500;
      }
    }
  }
  &_sizeplayer {
    &_content {
      margin-top: 0.25rem;
      font-size: 0.875rem;
    }
    &_title {
      font-weight: 500;
      &_position {
        padding: 0 0.25rem 0 0;
      }
      &_type {
        color: var(--clr-grey-2);
      }
    }
  }
}

.slfrssmr_ra_table {
  --ra-table-size: 4.25rem;
  --clr-rtc-range: var(--clr-range-default);
  --table-radius: 2px;

  margin: auto 0 auto 0;
  height: var(--ra-table-size);
  width: var(--ra-table-size);
  display: grid;
  flex-shrink: 0;
  grid-template-columns: repeat(13, 1fr);
  grid-template-rows: repeat(13, 1fr);
  border-radius: var(--table-radius);
  overflow: hidden;
  background: var(--clr-black-0);
  &_rtc {
    background: var(--clr-rtc-range);
    opacity: var(--opacity-range);
    transition: 0.1s;
  }
}
</style>
